<template>
  <div class="card">
    <div class="card-body">
      <b-table
        :empty-text="empty"
        show-empty
        :items="approvals"
        :fields="fields"
        :busy="loading"
        no-border-collapse
        responsive
      >
        <template #head(actions)>
          Acciones
          <CheckPermission permission="ED265">
            <b-button
              class="badge-glow mb-2 ml-3"
              variant="warning"
              size="sm"
              data-cy="download"
              v-b-tooltip="'Descargar listado'"
              v-on:click="descargarListado()"
            >
              <feather-icon icon="DownloadIcon"/>
            </b-button>
          </CheckPermission>
        </template>
        <template #cell(desatendida)="{ item }">
        <span class="badge badge-warning" v-if="item.desatendida === 1">
          SI
        </span>
          <span class="badge badge-secondary" v-if="item.desatendida !== 1">
          NO
        </span>
        </template>
        <template #cell(in_progress)="{ item }">
        <span class="badge badge-success" v-if="item.in_progress === 0">
          {{ item.in_progress }}
        </span>
          <span class="badge badge-warning" v-if="item.in_progress > 0">
          {{ item.in_progress }}
        </span>
        </template>
        <template #cell(type)="{ item }">
          <div class="d-flex justify-content-start align-items-center">
            <vs-icon
              icon="arrow_forward"
              class="cursor-default mr-1"
              size="small"
              v-tooltip="'Normal'"
              v-if="item.executionType !== 'P'"
            />
            <vs-icon
              icon="attach_money"
              class="cursor-pointer"
              size="small"
              v-tooltip="'Por monto'"
              v-if="item.executionType === 'P'"
            />
            <div>
            <span
              class="cursor-default mr-2" v-tooltip="getType(item.type)"
            >
              {{ getType(item.type) }}
            </span>
              <span
                class="badge badge-warning"
                v-tooltip="findPurchaseType(item.objectCategoryType)"
                v-if="findPurchaseType(item.objectCategoryType)"
              >
              {{ findPurchaseType(item.objectCategoryType) | truncate(20) }}
            </span>
            </div>
          </div>
        </template>
        <template #cell(name)="{ item }">
          <div class="row mt-2">
            <div class="col-11">
              <h4 class="text-primary mb-1">{{ item.name }}</h4>
              <small
                v-if="item.app === 'ED'"
                     class="mr-3 badge badge-primary"
              >
                {{ item.app }}
              </small>
              <small
                v-if="item.app === 'FEB'"
                class="mr-3 badge badge-warning"
              >
                {{ item.app }}
              </small>
              <small
                v-b-tooltip.hover.bottom="'Descripción'"
                class="text-secondary"
              >
                <b>{{ item.description.toLowerCase() }}</b>
              </small>
            </div>

          </div>
          <hr class="col-9 mb-2 mt-0">
          <div class="row">
            <div class="col-12 d-flex align-items-start">
              <vs-chip
                v-tooltip="'Cantidad de documentos en curso. Puedes hacer click para verlas!'"
                class="mr-3 cursor-pointer"
                @click.native="seeDocuments(item)"
              >
                <vs-avatar
                  :text="item.in_progress.toString()"
                  badgeColor="warning"
                  :color="item.in_progress > 0 ? '#28c76f' : 'gray'"
                />
                Aprobaciones
              </vs-chip>
              <vs-chip
                class="mr-3"
                v-tooltip="'Unidad'"
                v-if="item.unitName"
              >
                <vs-avatar icon="apartment"/>
                {{ item.unitName }}
              </vs-chip>
              <vs-chip
                class="mr-3"
                v-tooltip="'Fecha de creación'"
                v-if="item.date"
              >
                <vs-avatar color="#ff9f43" icon="date_range"/>
                {{ item.date | dateFormat }}
              </vs-chip>
              <vs-chip
                class="mr-3"
                v-tooltip="findPurchaseType(item.objectCategoryType)"
              >
                <vs-avatar
                  color="#ff9f43"
                  v-b-tooltip.hover.left="`Tipo de ejecución:\
                  ${item.executionType === 'P' ? 'Por monto':'Normal'}`"
                  :icon="item.executionType === 'P' ? 'attach_money' : 'arrow_forward'"
                />
                <span class="cursor-default mr-2">{{ getType(item.type) }}</span>
              </vs-chip>

            </div>

          </div>
        </template>
        <template #cell(actions)="{ item }">
          <div class="col-1 p-0">
            <TableActions :load="load" :fetchTemplates="fetchTemplates" :item="item"/>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
      <div
        class="row margin"
        v-if="templatePaginationData && templatePaginationData.totalPaginas > 1"
      >
        <div class="col-12">
          <FbPaginacion
            :total="templatePaginationData.totalPaginas"
            :max="10"
            v-model="page"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import TableActions from '@/febos/chile/approvals/components/templates/TableActions';
import { updateSearchParams } from '@/febos/global/utils/router';
import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';
import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  name: 'ApprovalsTable',
  components: { CheckPermission, TableActions, FbPaginacion },
  props: ['company'],
  data() {
    return {
      fields: [
        // { key: 'app', label: 'App' },
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'description', label: 'Descripción' },
        { key: 'desatendida', label: 'Desatendida' },
        { key: 'in_progress', label: 'En curso' },
        { key: 'type', label: 'Tipo' },
        { key: 'actions', label: 'Acciones' }
      ],
      loading: true,
      filters: [
        {
          name: 'aprobacionesEstado',
          filter: 'aprobacionesEstado:Y'
        },
        {
          name: 'iutEmpresa',
          filter: `iutEmpresa:${this.company.id}`
        },
        {
          name: 'app',
          filter: `app:ED`
        }
      ],
      empty: 'No hay resultados',
      page: parseInt(this.$route.query.page, 10) || 1,
      pageFromFilter: false
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      if (!this.pageFromFilter) {
        this.loading = true;
        await this.fetchTemplates();
      }
    },
    async filters() {
      this.pageFromFilter = true;
      this.page = 1;
      await this.debounceFetch();
      this.pageFromFilter = false;
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'approvalsTemplates',
      'purchaseTypes',
      'referenceApprovals',
      'templatePaginationData'
    ]),
    approvals() {
      return this.approvalsTemplates.map((a) => ({
        id: a.id,
        name: a.nombre,
        app: a.app,
        date: a.fechaCreacion,
        unitName: a.unidadNombre,
        description: a.descripcion,
        desatendida: a.desatendida || 0,
        in_progress: a.aprobacionesActivas,
        is_reversible: a.reversible,
        type: a.tipoObjeto,
        objectCategoryType: a.tipoObjetoCategoria,
        executionType: a.tipoEjecucion
      }));
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalsTemplates',
      'getApprovalsTemplatesCsv',
      'getPurchaseType'
    ]),
    seeDocuments(item) {
      if (!item.in_progress) return;
      const route = this.$router.resolve({
        name: 'approval-trays',
        params: { view: 'general' },
        query: {
          filters: `app:FEB,ED|aprobacionesEjecucionEstadoId:3|aprobacionesReferenciaId:${item.id}`
        }
      });
      window.open(route.href, '_blank');
    },
    load(arg) {
      this.loading = arg;
    },
    debounceFetch: _.debounce(async function debounceFetch() {
      this.loading = true;
      await this.fetchTemplates();
      this.loading = false;
    }, 350),
    getType(type) {
      return this.referenceApprovals.find((ra) => type === ra.valor)?.descripcion;
    },
    findPurchaseType(objectCategoryType) {
      return this.purchaseTypes.find(
        (pt) => objectCategoryType === pt.valor
      )?.descripcion;
    },
    async descargarListado() {
      this.loading = true;
      try {
        const response = await this.getApprovalsTemplatesCsv({
          params: {
            filtros: this.filters.map((f) => f.filter).join('|'),
            pagina: this.page,
            orden: '-fechaCreacion',
            itemsPorPagina: 8,
            csv: 'Y'
          }
        });
        this.$vs.notify({
          title: '¡Super!',
          text: 'Acción realizada con éxito, ya puedes ver el archivo en tus descargas',
          color: 'success',
          time: 10000,
          position: 'top-center'
        });
        const { url } = response.data;
        window.open(url, '_blank');
      } finally {
        this.loading = false;
      }
    },
    async fetchTemplates() {
      this.loading = true;
      try {
        return await this.getApprovalsTemplates({
          params: {
            filtros: this.filters.map((f) => f.filter).join('|'),
            pagina: this.page,
            orden: '-fechaCreacion',
            itemsPorPagina: 10
          }
        });
      } finally {
        this.loading = false;
      }
    },
    manageFilter(obj) {
      this.filters = this.filters.filter((f) => f.name !== obj.filterName);
      if (obj.filter === '*') return;
      if (obj.filter === `${obj.filterName}$`) return;
      this.filters.push({
        name: obj.filterName,
        filter: obj.filter
      });
    },
    setFilterTable() {
      this.$root.$on('tipoEjecucion', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('tipoObjeto', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('aprobacionesActivas', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('unidad', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('nombre', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('aprobacionesEstado', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('app', (obj) => {
        this.manageFilter(obj);
      });
      this.$root.$on('aprobacionesAtendidas', (obj) => {
        this.manageFilter(obj);
      });
    }
  },
  mounted() {
    this.setFilterTable();
  },
  created() {
    this.loading = true;
    this.getPurchaseType();
    this.fetchTemplates();
  }
};
</script>

<style scoped>
.badge {
  height: fit-content;
}

.margin {
  margin-right: 40px;
}
</style>
